//replaces search-table-with-header-compare.html
import type { FC } from "react";

import styled from "styled-components";

import { DASHBOARD_ID_PREVIEW_MODE } from "app/components/dashboard/widget-wizard/constants";
import { MiniFlexTable } from "app/components/React/Table/FlexTable/Mini/MiniFlexTable";
import { SWReactTable } from "app/components/React/Table/SWReactTable";
import { TableNoData } from "app/components/table-no-data/TableNoData";
import { WidgetLegendContainerV2 } from "app/dashboards/view-components/widget-legend/WidgetLegendContainer-v2";
import { KeywordsOverviewHeader } from "app/pages/website-analysis/traffic-sources/search/components/keywordsTableOverview";

import type { IDashboardWidgetInterface } from "../utils/DashboardWidgetsInterfaces-v2";

import type { ITableWidget } from "./TableTemplate-v2";

const Spacer = styled.div`
    width: 100%;
    height: 23px;
`;
export const SearchTableWithHeaderSingleTemplateV2: FC<IDashboardWidgetInterface<ITableWidget>> = (props) => {
    const { widget } = props;
    return (
        <>
            {widget.viewOptions.tableCompareLegend ? (
                <WidgetLegendContainerV2
                    widget={widget}
                    className="swWidget-legend geography-table-legend"
                    items={widget.legendItems}
                />
            ) : null}
            {widget.dashboardId != DASHBOARD_ID_PREVIEW_MODE ? (
                <KeywordsOverviewHeader
                    organic={widget.getSingleHeaderItem("organic")}
                    paid={widget.getSingleHeaderItem("paid")}
                    total={widget.getSingleHeaderItem("total")}
                    percentage={widget.getSingleHeaderItem("percentage")}
                    webSource={widget.getWidgetModel().webSource}
                    isFetching={false}
                    dashboard={true}
                />
            ) : null}
            {widget.dashboardId != DASHBOARD_ID_PREVIEW_MODE ? <hr /> : null}
            {widget.dashboardId != DASHBOARD_ID_PREVIEW_MODE ? <Spacer /> : null}
            {widget.metadata.options.tableType === "widgetTable" && widget.data.Records.length ? (
                <SWReactTable
                    tableData={widget.data}
                    tableColumns={widget.metadata.columns}
                    tableOptions={widget.metadata.options}
                    onSort={widget.onSort}
                    onItemClick={widget.onItemClick}
                    onItemToggleSelection={widget.onToggleSelection}
                    onSelectAllRows={widget.selectAllPageRows}
                    allRowsSelected={widget.allRowsSelected}
                    className={widget.tableClassName}
                />
            ) : null}
            {widget.metadata.options.tableType === "swTable--simple" && widget.data.Records.length ? (
                <MiniFlexTable
                    tableData={widget.data}
                    tableColumns={widget.metadata.columns}
                    tableOptions={widget.metadata.options}
                    tablePayload={{ items: widget.data.Items }}
                />
            ) : null}
            {widget.metadata.options.emptyResults ? <TableNoData config={widget.errorConfig} /> : null}
        </>
    );
};
